// src/utils/validate.js

/**
 * 手机号验证
 * @param {string} value
 * @returns {Boolean}
 */
export function validatePhone(value) {
  const reg = /^1[3-9]\d{9}$/
  return reg.test(value.trim())
}

/**
 * 身份证验证（简单版）
 * @param {string} value
 * @returns {Boolean}
 */
export function validateIDCard(value) {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  return reg.test(value.trim())
}

/**
 * 车牌号验证（包含新能源车牌）
 * @param {string} value
 * @returns {Boolean}
 */
export function validateLicensePlate(value) {
  const reg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳]$/
  return reg.test(value.trim().toUpperCase())
}

/**
 * 通用验证器生成器
 * @param {Function} validateFn 验证函数
 * @param {string} message 错误提示
 */
export function createValidator(validateFn, message) {
  return (rule, value, callback) => {
    if (!value) return callback()
    if (validateFn(value)) {
      callback()
    } else {
      callback(new Error(message))
    }
  }
}

// 全局验证规则（可直接在element表单rules中使用）
export const formRules = {
  phone: {
    validator: createValidator(validatePhone, '请输入正确的手机号码'),
    trigger: 'blur'
  },
  idCard: {
    validator: createValidator(validateIDCard, '请输入正确的身份证号码'),
    trigger: 'blur'
  },
  licensePlate: {
    validator: createValidator(validateLicensePlate, '请输入正确的车牌号码'),
    trigger: 'blur'
  }
}
